var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_c('b-badge',{attrs:{"variant":_vm.statusConfig.variant}},[_vm._v(" "+_vm._s(_vm.$t("status"))+" - "+_vm._s(_vm.$t(_vm.statusConfig.label))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }